import React from 'react';
import { Col, Row, Button, InputGroup, FormControl, FormGroup, Form } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import constants from '../../util/constants';
import LoadingSpinner from '../../LoadingSpinner';
import "react-table/react-table.css";
import 'bootstrap/dist/css/bootstrap.css';
import FontAwesome from 'react-fontawesome';
import { removeRow } from '../../gridHelpers/gridHelpers';
import { initialize, addYear, addRemovedRow, setTotal, setFromTotal, showCommentDialog, showSaveDialog, getCommentsForRow, getCommentIconForField } from '../../Allocation/AllocationHelper';
import ReactTooltip from "react-tooltip";
import NPReactTable from '../../NPReactTable';
import Dialog from 'react-bootstrap-dialog';
import * as Grants from '../../util/grants';
import { hasGrant } from '../../util/grantHelper';
import './style.scss';
import CustomerTransportation from '../CustomerTransportation';

const { API_BASE_URL } = constants;

class CustomerAllocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      header: this.props.apiToken ? {
        'Authorization': 'Bearer ' + this.props.apiToken,
        'Accept': 'application/octet-stream'
      } : {},
      clientCountry: this.props.clientCountry,
      allocations: this.props.allocationWrapper.Allocations ? this.props.allocationWrapper.Allocations : [],
      transporters: this.props.transportationData ? this.props.transportationData : [],
      expanded: {},
      page: 0,
      pageSize: 10,
      resized: [],
      selectedYear: {},
      availableYears: this.props.allocationWrapper.AvailableYears ? this.props.allocationWrapper.AvailableYears : [],
      isLoading: false,
      removedAllocations: [],
      removedRow: -1,
      legalEntity: this.props.allocationWrapper.LegalEntity ? this.props.allocationWrapper.LegalEntity : '',
      showError: false,
      errorMessage: "",
      showCapacityWarning: false,
      capacityWarning: "",
      allocationsWithoutCapacity: [],
      canEdit: false,
      canAddComment: false,
      currentMaxLoad: 0,
      userType: this.props.userType,
      unsavedChanges: false,
    };
    this.getColumns = this.getColumns.bind(this);
    this.addNewRow = this.addNewRow.bind(this);
    this.reloadAllocation = this.reloadAllocation.bind(this);
    this.getBody = this.getBody.bind(this);
    this.save = this.save.bind(this);
    this.getBool = this.getBool.bind(this);
    this.showAddYearDialog = this.showAddYearDialog.bind(this);
    this.addRemovedRow = this.addRemovedRow.bind(this);
    this.setCurrentMaxWeightCallback = this.setCurrentMaxWeightCallback.bind(this);
    this.okForMaxWeight = this.okForMaxWeight.bind(this);

    initialize(this);
  }

  componentDidMount() {
    this.getAllocationSettings();
    this.setState({ canEdit: hasGrant(Grants.TYPES.CustomerProfile_EditCustomerAllocation), canAddComment: hasGrant(Grants.TYPES.Allocation_AddAllocationComments) });
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  setAllocationSettings(year) {
    let searchSettings = {Year: year};
    axios.post(API_BASE_URL + 'Allocation/SetAllocationSettings', searchSettings, { headers: this.state.header })
      .then(response => {
      })
      .catch(error => {
        console.log(error)
      })
  }

  getAllocationSettings() {
    axios.get(API_BASE_URL + 'Allocation/GetAllocationSettings', {headers: this.state.header })
      .then(response => {
        let chosenYear = this.state.availableYears.find(x => x === parseInt(response.data.Year, 10));
        if(chosenYear)
        {
          this.setState({selectedYear: { label: chosenYear, value: chosenYear }});
        }
      })
      .catch(error => {
        console.log(error);
      })
  }

  checkForAvailableCapacity(row) {
    if (row.Changed || row.AllocationId === -1) {
      axios.post(API_BASE_URL + 'Allocation/CheckForAvailableCapacity', row, { headers: this.state.header })
        .then(response => {
          let capacityAvailable = response.data;
          if (capacityAvailable) {
            row.EnoughCapacity = true;
            this.setState({ showCapacityWarning: this.state.allocations.some(x => x.EnoughCapacity === false) });
          }
          else {
            row.EnoughCapacity = false;
            this.setState({ showCapacityWarning: this.state.allocations.some(x => x.EnoughCapacity === false), capacityWarning: "Warning: Not enough capacity available for customer allocations." });
          }
        })
        .catch(error => {
          this.setState({ showError: false, errorMessage: error.ExceptionMessage });
        });
    }
  }

  save() {
    let allocationWrapper = {};
    allocationWrapper.Allocations = this.state.allocations;
    allocationWrapper.removedAllocations = this.state.removedAllocations;
    allocationWrapper.TransporterMaxWeight = this.state.currentMaxLoad;

    let comment = this.dialog.promptInput && this.dialog.promptInput.state ? this.dialog.promptInput.state.value : null;
    if (comment) {
      let newComment = { CommentId: -1, Year: this.state.selectedYear.value, CustomerId: this.props.clientCode, Comment: comment, AllocationId: -1 }
      allocationWrapper.Allocations.filter(x => x.Changed).forEach(x => x.Comments.push(newComment));
    }

    this.setState({ isLoading: true });
    axios.post(API_BASE_URL + 'Allocation/SaveCustomerAllocation', allocationWrapper, { headers: this.state.header })
      .then(response => {
        let data = response.data;
        this.setState({ isLoading: false, showError: false, success: true, allocations: data.Allocations, comments: data.Comments, removedAllocations: [] });
        initialize(this);
      })
      .catch(error => {
        let data = error.response.data;
        this.setState({ isLoading: false, showError: true, success: false, errorMessage: data.ExceptionMessage });
      });
  }

  reloadAllocation(copy) {
    if (this.props.clientCode === undefined || this.props.clientCode.length === 0 || this.state.selectedYear === undefined) {
      return;
    }
    let customer = '?ccr=' + this.props.clientCode;
    let year = '&year=' + this.state.selectedYear.value;
    let copyData = copy ? '&copy=true' : '&copy=false';
    if (copy)
      addYear(this);
    this.setState({ isLoading: true });
    axios.get(API_BASE_URL + 'Allocation/ReloadCustomerAllocation' + customer + year + copyData, { headers: this.state.header })
      .then(response => {
        let data = response.data;
        this.setState({ isLoading: false, showError: false, success: true, allocations: data.Allocations, comments: data.Comments, availableYears: data.AvailableYears, removedAllocations: [], legalEntity: data.LegalEntity, page: 0 });
        initialize(this);
      })
      .catch(error => {
        let data = error.response.data;
        this.setState({ isLoading: false, showError: true, success: false, errorMessage: data.Message });
      });
  }

  showAddYearDialog() {
    this.dialog.show({
      title: "Add year.",
      body: "Do you want to copy allocations from the selected year?",
      actions: [
        Dialog.CancelAction(),
        Dialog.Action('With data', () => this.reloadAllocation(true), 'btn-info'),
        Dialog.Action('Without data', () => addYear(this), 'btn-info')
      ],
    });
  }

  addNewRow() {
    if (this.okToAddAnotherRow(this)) {
      this.state.allocations.unshift({
        AllocationId: -1, PM: '', Country: this.state.clientCountry, Grade: '', Grammage: '', ProdType: 2, EndUse: '', Comments: [],
        M1: 0, M2: 0, M3: 0, M4: 0, M5: 0, M6: 0, M7: 0, M8: 0, M9: 0, M10: 0, M11: 0, M12: 0, 
        GuiM1: 0, GuiM2: 0, GuiM3: 0, GuiM4: 0, GuiM5: 0, GuiM6: 0, GuiM7: 0, GuiM8: 0, GuiM9: 0, GuiM10: 0, GuiM11: 0, GuiM12: 0, 
        Total: 0, SetFromTotal: false, SetFromMaxWeight: false, Year: this.state.selectedYear.value, Type: 1, CustomerId: this.props.clientCode
      });
      this.setState({
        unsavedChanges: true
      });
    }
  }

  addRemovedRow() {
    if (this.state.removedRow === -1)
      return;

    this.state.removedAllocations.push(this.state.removedRow);
    this.state.removedRow = -1;
    this.setState({
      unsavedChanges: true
    });
  }

  okToAddAnotherRow(self) {
    if (self.state.allocations === undefined)
      return true;
    return (self.state.allocations.length === 0 || self.state.allocations.filter(d => d.PM === "").length === 0);
  }

  okForMaxWeight(self) {
    if(self.state.allocations.some((element) => element.SetFromMaxWeight === true))
    {
      return self.state.currentMaxLoad > 0;
    }
    return true;
  }

  getBool(row, target) {
    return row === target;
  }

  showContextMenu = (e, row) => {
    e.preventDefault();
    showCommentDialog(e.target, row, this);
  };

  help() {
    alert('\u2795 Adds an allocation row.\r\u2796 Removes an allocation row (after a confirmation question).\rRight-click a field to bind a comment to that field or row.\rPress Save to save your work and add an optional general comment.');
  }

  setCurrentMaxWeightCallback(value) {
    this.setState({currentMaxLoad: value});
  }

  

  getColumns(editable) {
    const data = this.state.allocations ? this.state.allocations : {};
    let plusStyle = this.okToAddAnotherRow(this) ? { color: 'black' } : { color: 'gray' };
    let self = this;
    let styleforNumbers = { width: '70px', height: '28px' };
    let styleforText = { width: '60px', height: '28px' };
    let greaseproofColumns = this.state.legalEntity === 'NP';
    let allocationStep = this.state.legalEntity === "NPBA" ? "1" : "0.1";
    let fromTotal = {
      Header: "Use prod. cycle",
      maxWidth: 95,
      id: 'SetFromTotal',
      className: 'SetFromTotal',
      Cell: row => (
        <div hidden={editable === false}>
          <input className="SetFromTotal" type="checkbox"
            disabled={editable === false}
            onChange={(e) => {
              if (e.target.checked) {
                row.original.SetFromTotal = true
              }
              else {
                row.original.SetFromTotal = false
              }
              this.setState({
                unsavedChanges: true
              });
            }}
            checked={row.original.SetFromTotal}>
          </input>
        </div>
      )
    };
    let fromMaxWeight = {
      Header: "Use max weight",
      maxWidth: 115,
      id: 'setFromMaxWeight',
      className: "setFromTotal",
      Cell: row => (
        <div hidden={editable === false}>
          <input className="SetFromTotal" type="checkbox"
            disabled={editable=== false}
            onChange={(e) => {
              if(e.target.checked) {
                row.original.SetFromMaxWeight = true
              }
              else {
                row.original.SetFromMaxWeight = false
              }
              this.setState({
                unsavedChanges: true
              });
            }}
            checked={row.original.SetFromMaxWeight}>
          </input>
        </div>
      )

    }

    let returnItem = [
      {
        columns: [
          {
            Header: props => <FontAwesome className="handy" name="question-circle" onClick={() => { this.help() }} />,
            maxWidth: 35,
            sortable: false,
            filterable: false,
            resizable: false,
            textAlign: "center",
            id: 'allocationId',
            show: editable,
            Cell: row => {
              let comments = getCommentsForRow(row.original);
              return (
                <div>
                  <span data-for="globalTip" data-tip={comments}>
                    <div style={{ textAlign: "center" }}>
                      {comments &&
                        <FontAwesome style={{ textAlign: "center" }} name="comments" />}
                    </div>
                  </span>
                </div>
              )
            }
          },
          {
            Header: props => <FontAwesome className="handy" name="plus" onClick={() => { if (editable) this.addNewRow() }} style={plusStyle} />,
            maxWidth: 20,
            filterable: false,
            sortable: false,
            id: 'addRemoveRow',
            textAlign: "center",
            resizable: false,
            show: editable,
            Cell: (props, row) => <span style={{ textAlign: "center" }}>
              {editable &&
                <FontAwesome className="handy" style={{ textAlign: "center" }} name="minus" onClick={
                  () => {
                    this.state.removedRow = props.row._original.AllocationId;
                    removeRow(data, props.row._original, this, this.addRemovedRow, 'Remove allocation row', 'Do you really want to remove this allocation row?');
                  }} />
              }</span>
          },
          {
            Header: "PM",
            maxWidth: 80,
            id: 'PM',
            className: 'PM',
            Cell: row => (
              <div>
                <span className="PM flexSpan">
                  <input name="PM" type="text" className="form-control input-sm"
                    disabled={editable === false}
                    style={styleforText}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.PM = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.PM}
                    onFocus={(e) => e.target.select()} >
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Country",
            maxWidth: 80,
            id: 'Country',
            className: 'Country',
            Cell: row => (
              <div>
                <span className="Country flexSpan">
                  <input name="Country" type="text" className="form-control input-sm"
                    disabled={editable === false}
                    style={styleforText}
                    maxLength="2"
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.Country = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.Country}
                    onFocus={(e) => e.target.select()}>
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Grade Code",
            show: greaseproofColumns,
            maxWidth: 80,
            id: 'Grade',
            className: 'Grade',
            Cell: row => (
              <div>
                <span className="Grade flexSpan">
                  <input name="Grade" type="text" className="form-control input-sm"
                    disabled={editable === false}
                    style={styleforText}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.Grade = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.Grade}
                    onFocus={(e) => e.target.select()} >
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Prod Type",
            show: greaseproofColumns,
            maxWidth: 90,
            id: 'ProdType',
            className: 'ProdType',
            Cell: row => (
              <div>
                <span className="ProdType flexSpan" id="typeSpan">
                  <div className="ProdType">
                    <label className="ProdType">Roll</label><br />
                    <input className="ProdType" type="checkbox"
                      disabled={editable === false}
                      onChange={(e) => {
                        if (e.target.checked) {
                          row.original.ProdType = 0
                        }
                        else {
                          row.original.ProdType = 2
                        }
                        row.original.Changed = row.original.AllocationId > 0 ? true : false;
                        this.setState({
                          unsavedChanges: true
                        });
                        this.checkForAvailableCapacity(row.original)
                      }}
                      checked={this.getBool(row.original.ProdType, 0)}>
                    </input>
                  </div>
                  <div className="ProdType" id="typeDiv">
                    <label className="ProdType">Sheet</label><br />
                    <input className="ProdType" type="checkbox"
                      disabled={editable === false}
                      onChange={(e) => {
                        if (e.target.checked) {
                          row.original.ProdType = 1
                        }
                        else {
                          row.original.ProdType = 2
                        }
                        row.original.Changed = row.original.AllocationId > 0 ? true : false;
                        this.setState({
                          unsavedChanges: true
                        });
                      }}
                      checked={this.getBool(row.original.ProdType, 1)} >
                    </input>
                  </div>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
        ]
      },
      {
        columns: [
          {
            Header: "Jan",
            maxWidth: 90,
            id: 'M1',
            className: 'M1',
            Cell: row => (
              <div>
                <span className="M1 flexSpan">
                  <input name="M1" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min=""
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM1 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM1 || '0'}
                    onFocus={(e) => e.target.select()}
                  >
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Feb",
            maxWidth: 90,
            id: 'M2',
            className: 'M2',
            Cell: row => (
              <div>
                <span className="M2 flexSpan">
                  <input name="M2" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min="0"
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM2 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM2 || '0'}
                    onFocus={(e) => e.target.select()}>
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Mar",
            maxWidth: 90,
            id: 'M3',
            className: 'M3',
            Cell: row => (
              <div>
                <span className="M3 flexSpan">
                  <input name="M3" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min="0"
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM3 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM3 || '0'}
                    onFocus={(e) => e.target.select()}>
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Apr",
            maxWidth: 90,
            id: 'M4',
            className: 'M4',
            Cell: row => (
              <div>
                <span className="M4 flexSpan">
                  <input name="M4" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min="0"
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM4 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM4 || '0'}
                    onFocus={(e) => e.target.select()} >
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "May",
            maxWidth: 90,
            id: 'M5',
            className: 'M5',
            Cell: row => (
              <div>
                <span className="M5 flexSpan">
                  <input name="M5" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min="0"
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM5 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM5 || '0'}
                    onFocus={(e) => e.target.select()}>
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Jun",
            maxWidth: 90,
            id: 'M6',
            className: 'M6',
            Cell: row => (
              <div>
                <span className="M6 flexSpan">
                  <input name="M6" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min="0"
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM6 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM6 || '0'}
                    onFocus={(e) => e.target.select()}>
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Jul",
            maxWidth: 90,
            id: 'M7',
            className: 'M7',
            Cell: row => (
              <div>
                <span className="M7 flexSpan">
                  <input name="M7" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min="0"
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM7 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM7 || '0'}
                    onFocus={(e) => e.target.select()}>
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Aug",
            maxWidth: 90,
            id: 'M8',
            className: 'M8',
            Cell: row => (
              <div>
                <span className="M8 flexSpan">
                  <input name="M8" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min="0"
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM8 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM8 || '0'}
                    onFocus={(e) => e.target.select()} >
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Sep",
            maxWidth: 90,
            id: 'M9',
            className: 'M9',
            Cell: row => (
              <div>
                <span className="M9 flexSpan">
                  <input name="M9" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min="0"
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM9 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM9 || '0'}
                    onFocus={(e) => e.target.select()} >
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Oct",
            maxWidth: 90,
            id: 'M10',
            className: 'M10',
            Cell: row => (
              <div>
                <span className="M10 flexSpan">
                  <input name="M10" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min="0"
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM10 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM10 || '0'}
                    onFocus={(e) => e.target.select()} >
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Nov",
            maxWidth: 90,
            id: 'M11',
            className: 'M11',
            Cell: row => (
              <div>
                <span className="M11 flexSpan">
                  <input name="M11" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min="0"
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM11 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM11 || '0'}
                    onFocus={(e) => e.target.select()} >
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Dec",
            maxWidth: 90,
            id: 'M12',
            className: 'M12',
            Cell: row => (
              <div>
                <span className="M12 flexSpan">
                  <input name="M12" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step={allocationStep}
                    min="0"
                    style={styleforNumbers}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiM12 = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      setTotal(row.original);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiM12 || '0'}
                    onFocus={(e) => e.target.select()} >
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
          {
            Header: "Total",
            maxWidth: 110,
            id: 'Total',
            className: 'Total',
            Cell: row => (
              <div>
                <span className="Total flexSpan">
                  <input name="Total" type="number" className="form-control input-sm"
                    disabled={editable === false}
                    step="1"
                    min="0"
                    style={{ width: '90px', height: '28px' }}
                    onBlur={(e) => { this.checkForAvailableCapacity(row.original) }}
                    onChange={(e) => {
                      row.original.GuiTotal = e.target.value;
                      row.original.Changed = row.original.AllocationId > 0 ? true : false;
                      let decimals = this.state.legalEntity == "NPBA" ? 0 : 1;

                      setFromTotal(row.original, decimals);
                      this.setState({
                        unsavedChanges: true
                      });
                    }}
                    value={row.original.GuiTotal || '0'}
                    onFocus={(e) => e.target.select()} >
                  </input>
                  {getCommentIconForField(row.column.id, row.original)}
                </span>
              </div>
            )
          },
        ]
      }
    ];
    if (editable)
      returnItem[1].columns.push(fromTotal);
      if(this.state.userType === "1")
      {
        returnItem[1].columns.push(fromMaxWeight);
      }
      
    return returnItem;
  }

  getBody(data, editable) {
    let changed = {
      backgroundColor: this.state.unsavedChanges ? 'pink' : '#00529c',
      border: this.state.unsavedChanges ? '2px solid red' : ''
    };
    if (this.state.isLoading) {
      return (
        <LoadingSpinner isLoading={true} />
      );
    }
    else if (!this.state.legalEntity) {
      return (
        <div />
      );
    }
    else {
      return (
        <div>
          <div>
            <Dialog ref={(el) => { this.dialog = el }} />
            <ReactTooltip id="globalTip" html place="bottom" effect="solid" />
            <NPReactTable
              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  style: {
                    overflow: 'visible'
                  }
                }
              }}
              getTrProps={(state, rowInfo) => {
                return {
                  onContextMenu: (e) => {
                    if (this.state.canAddComment && editable)
                      this.showContextMenu(e, rowInfo.original);
                  }
                }
              }}
              className="margin-top-5 np-react-table allocationTable"
              data={data}
              ref={(r) => { this.reactTable = r }}
              // showPagination={false}
              // showPageSizeOptions={false}
              sortable={false}
              hasHeaderGroups={false}
              minRows={5}
              columns={this.getColumns(editable)}
              defaultPageSize={10}
              // Controlled props
              sorted={this.state.sorted}
              page={this.state.page}
              pageSize={this.state.pageSize}
              expanded={this.state.expanded}
              resized={this.state.resized}
              onResizedChange={resized => { this.setState({ resized }) }}
              onPageChange={
                page => {
                  this.setState({ page, expanded: {} });
                }
              }
              onPageSizeChange={(pageSize, page) => {
                this.setState({ page, pageSize, expanded: {} });
              }
              }
            />
          </div>
          <div>
            {editable &&
              <Row className="margin-top-10">
                <Col xs={12}>
                  <Button bsStyle="primary" style={changed} disabled={this.okToAddAnotherRow(this) === false || this.okForMaxWeight(this) === false} onClick={evt => { showSaveDialog(this, "Save allocation", hasGrant(Grants.TYPES.Allocation_AddAllocationComments)); }}>
                    Save
                  </Button>
                </Col>
              </Row>
            }
          </div>
        </div>
      )
    }
  }

  render() {
    const data = this.state.allocations ? this.state.allocations : {};
    let years = this.state.availableYears ? this.state.availableYears.map((y) => ({ label: y, value: y })) : [];
    let editable = this.state.canEdit;
    let addYear = hasGrant(Grants.TYPES.CustomerProfile_AddAllocationYear);
    let errorMessage = this.state.errorMessage;
    let showError = this.state.showError;

    const transporterOptions = this.state.transporters.map((value) => { return value === undefined ? null : { label: value.SHORT_NAME + ' - ' + value.MAX_LOAD + " kg", value: value.TRANSPORTER_CODE, object: value } })

    return (
      <div>
        <legend className="mylegend allocationLegend">Allocation</legend>
        <Row>
          <Col xs={5} className="addYear">
          <Form inline>
          <FormGroup>
          <InputGroup>
          <InputGroup.Addon>Year</InputGroup.Addon>
            <Select isSearchable={true}
              styles={{
                valueContainer: (provided) => ({
                  ...provided,
                  minWidth: '50px'
                }),
              }}
              isClearable={false}
              options={years}
              menuContainerStyle={{ zIndex: 5 }}
              value={this.state.selectedYear}
              onChange={evt => {
                this.state.selectedYear = evt;
                this.setAllocationSettings(evt.value);
                this.reloadAllocation();
                this.setState({});
              }}
            />
            </InputGroup>

            </FormGroup>
            </Form>
            {addYear && editable &&
              <Button bsStyle="primary" className="btn-sm" onClick={evt => { this.showAddYearDialog(this); }}>
                Add Year
              </Button>
            }
            {this.state.showCapacityWarning &&
              <span class="errorMessage">
                {this.state.capacityWarning}
              </span>
            }
          </Col>
          <Col xs={7}>
            <Row className="pull-right">
              {this.state.userType === "1"
                ? <CustomerTransportation transporterData={this.state.transporters} header={this.state.header} onWeightChanged={this.setCurrentMaxWeightCallback}/> 
                : null
              }
            
            </Row>
          </Col>
        </Row>

        {this.getBody(data, editable)}
      </div>
    );
  }
}

export default CustomerAllocation;